/* Katia & Bony — global theme behaviour (no dependencies) */
(function () {
  'use strict';

  /* Sidebar drawer + accordion ------------------------------------------- */
  function openDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var btn = document.querySelector('[data-drawer-open]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    var btn = document.querySelector('[data-drawer-open]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-drawer-open]')) { openDrawer(); return; }
    if (event.target.closest('[data-drawer-close]')) { closeDrawer(); return; }

    var acc = event.target.closest('[data-acc]');
    if (acc) {
      var sub = acc.nextElementSibling;
      var open = acc.getAttribute('aria-expanded') === 'true';
      acc.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (sub) sub.classList.toggle('is-open', !open);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  /* Variant picker: keep the URL / hidden id in sync with selects -------- */
  function initVariantPickers() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var variantsEl = form.querySelector('[data-variants]');
      if (!variantsEl) return;

      var variants = JSON.parse(variantsEl.textContent || '[]');
      var idInput = form.querySelector('[name="id"]');
      var priceEl = form.querySelector('[data-price]');
      var addBtn = form.querySelector('[data-add-to-cart]');
      var selects = form.querySelectorAll('[data-option-select]');

      function update() {
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === chosen[i]; });
        });
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (priceEl && match.price != null) {
          priceEl.textContent = formatMoney(match.price);
        }
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available
            ? addBtn.dataset.labelAdd
            : addBtn.dataset.labelSoldout;
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', update); });
      update();
    });
  }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount(_no_decimals|_with_comma_separator)?\s*\}\}/, amount);
  }

  /* Localization: custom click-to-open dropdown -------------------------- */
  function initLocalization() {
    // Fallback for any plain selects (no custom dropdown wrapper)
    document.querySelectorAll('[data-localization-form] select:not([aria-hidden="true"])').forEach(function (sel) {
      sel.addEventListener('change', function () { sel.closest('form').submit(); });
    });

    document.querySelectorAll('[data-loc-dropdown]').forEach(function (dd) {
      var toggle = dd.querySelector('[data-loc-toggle]');
      var select = dd.querySelector('select');
      if (!toggle) return;

      function close() { dd.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); }

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = dd.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      dd.querySelectorAll('[data-loc-value]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          if (!select) return;
          select.value = opt.dataset.locValue;
          var form = select.closest('form');
          if (form) form.submit();
        });
      });

      document.addEventListener('click', function (e) { if (!dd.contains(e.target)) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }

  /* Hero slideshow -------------------------------------------------------- */
  function initSlideshows() {
    document.querySelectorAll('[data-slideshow]').forEach(function (root) {
      var slides = root.querySelectorAll('[data-slide]');
      if (slides.length < 2) return;
      var viewport = root.querySelector('.hero__viewport') || root;
      var prevBtn = root.querySelector('[data-slide-prev]');
      var nextBtn = root.querySelector('[data-slide-next]');
      var current = 0;
      var timer;

      function show(i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
      }
      function next() { show(current + 1); }
      function prev() { show(current - 1); }
      function restart() { clearInterval(timer); timer = setInterval(next, 6000); }

      if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });

      // Drag / swipe (pointer events = mouse + touch)
      var startX = null, dragging = false, moved = false;
      viewport.addEventListener('pointerdown', function (e) {
        if (e.button && e.button !== 0) return;
        startX = e.clientX; dragging = true; moved = false;
      });
      viewport.addEventListener('pointermove', function (e) {
        if (dragging && Math.abs(e.clientX - startX) > 8) moved = true;
      });
      window.addEventListener('pointerup', function (e) {
        if (!dragging) return;
        dragging = false;
        var dx = e.clientX - startX; startX = null;
        if (Math.abs(dx) > 50) {
          var rtl = document.documentElement.getAttribute('dir') === 'rtl';
          if ((dx < 0) !== rtl) { next(); } else { prev(); }
          restart();
        }
      });
      // Suppress click navigation if the pointer was dragged
      viewport.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);

      restart();
    });
  }

  /* Announcement bar slider (horizontal auto-slide) ---------------------- */
  function initAnnouncement() {
    document.querySelectorAll('[data-announcement]').forEach(function (bar) {
      var track = bar.querySelector('[data-announcement-track]');
      var slides = bar.querySelectorAll('[data-announcement-slide]');
      if (!track || slides.length < 2) return;
      var current = 0;
      var rtl = document.documentElement.getAttribute('dir') === 'rtl';
      function show(i) {
        current = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (rtl ? '' : '-') + (current * 100) + '%)';
      }
      var delay = parseInt(bar.getAttribute('data-autoplay'), 10);
      if (!delay || delay <= 0) delay = 5000; // always rotate when multiple messages
      setInterval(function () { show(current + 1); }, delay);
    });
  }

  /* Collection filter drawer (off-canvas, opens from left) ---------------- */
  function initFilterDrawer() {
    var drawer = document.querySelector('[data-filter-drawer]');
    if (!drawer) return;
    function open() {
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var btn = document.querySelector('[data-filter-open]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }
    function close() {
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      var btn = document.querySelector('[data-filter-open]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-filter-open]')) { event.preventDefault(); open(); }
      else if (event.target.closest('[data-filter-close]')) { close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* Product gallery ------------------------------------------------------- */
  function initGallery() {
    var stage = document.querySelector('[data-product-stage]');
    if (!stage) return;
    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        stage.src = thumb.dataset.full;
        document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* Product image lightbox (slider + thumbnails) ------------------------- */
  function initProductGallery() {
    var modal = document.querySelector('[data-pgallery]');
    if (!modal) return;
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-pgallery-item]'));
    if (!items.length) return;
    var stage = modal.querySelector('[data-pgallery-stage]');
    var thumbs = Array.prototype.slice.call(modal.querySelectorAll('[data-pgallery-thumb]'));
    var images = items.map(function (el) { return el.dataset.full; });
    var current = 0;

    function show(i) {
      current = (i + images.length) % images.length;
      if (stage) stage.src = images[current];
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === current); });
      var active = thumbs[current];
      if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'center' });
    }
    function open(i) {
      show(i);
      modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    items.forEach(function (el, i) {
      el.addEventListener('click', function (e) { e.preventDefault(); open(i); });
    });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-pgallery-close]')) { close(); return; }
      if (e.target.closest('[data-pgallery-prev]')) { show(current - 1); return; }
      if (e.target.closest('[data-pgallery-next]')) { show(current + 1); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
    });

    // Swipe on the stage
    var startX = null;
    var stageEl = modal.querySelector('.pgallery__stage');
    if (stageEl) {
      stageEl.addEventListener('pointerdown', function (e) { startX = e.clientX; });
      window.addEventListener('pointerup', function (e) {
        if (startX === null) return;
        var dx = e.clientX - startX; startX = null;
        if (Math.abs(dx) > 50) { if (dx < 0) show(current + 1); else show(current - 1); }
      });
    }
  }

  /* Quantity steppers ----------------------------------------------------- */
  function initQuantity() {
    document.addEventListener('click', function (event) {
      var minus = event.target.closest('[data-qty-minus]');
      var plus = event.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var wrap = (minus || plus).closest('.quantity');
      var input = wrap && wrap.querySelector('[data-qty-input], input[type="number"]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      input.value = plus ? val + 1 : Math.max(1, val - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* Cart drawer ----------------------------------------------------------- */
  function openCart() {
    var d = document.querySelector('[data-cart-drawer]');
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    var d = document.querySelector('[data-cart-drawer]');
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    var itemsEl = document.querySelector('[data-cart-items]');
    var footer = document.querySelector('[data-cart-footer]');
    var empty = document.querySelector('[data-cart-empty]');
    if (!itemsEl) return;

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = '(' + cart.item_count + ')';
    });

    var shipBar = document.querySelector('[data-ship-bar]');
    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '';
      if (footer) footer.hidden = true;
      if (empty) empty.hidden = false;
      if (shipBar) shipBar.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (footer) footer.hidden = false;

    itemsEl.innerHTML = cart.items.map(function (item) {
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" width="64" height="80" loading="lazy">' : '';
      var variant = item.product_has_only_default_variant ? '' : '<div class="cart-line__variant">' + (item.variant_title || '') + '</div>';
      return '' +
        '<div class="cart-line" data-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="cart-line__media">' + img + '</a>' +
          '<div class="cart-line__info">' +
            '<a href="' + item.url + '" class="cart-line__title">' + item.product_title + '</a>' +
            variant +
            '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
            '<div class="cart-line__controls">' +
              '<div class="quantity quantity--sm">' +
                '<button type="button" class="quantity__btn" data-line-minus aria-label="Decrease">−</button>' +
                '<input type="number" class="cart-line__qty" value="' + item.quantity + '" min="0" data-line-qty>' +
                '<button type="button" class="quantity__btn" data-line-plus aria-label="Increase">+</button>' +
              '</div>' +
              '<button type="button" class="cart-line__remove" data-line-remove>' + (window.theme.strings.remove || 'Remove') + '</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');

    var sub = document.querySelector('[data-cart-subtotal]');
    if (sub) sub.textContent = formatMoney(cart.total_price);

    // Free shipping progress bar
    var threshold = window.theme.freeShipping;
    if (shipBar && threshold && threshold > 0) {
      shipBar.hidden = false;
      var msg = shipBar.querySelector('[data-ship-msg]');
      var fill = shipBar.querySelector('[data-ship-fill]');
      var remaining = threshold - cart.total_price;
      if (remaining > 0) {
        msg.innerHTML = 'You are <strong>' + formatMoney(remaining) + '</strong> away from free shipping';
      } else {
        msg.innerHTML = '🎉 You have unlocked <strong>free shipping</strong>';
      }
      fill.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
    } else if (shipBar) {
      shipBar.hidden = true;
    }
  }

  function fetchCart(open) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (open) openCart(); return cart; });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); });
  }

  function quickAdd(variantId, el) {
    if (el) { el.disabled = true; el.classList.add('is-loading'); }
    openCart();
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function () { return fetchCart(false); })
      .catch(function () { closeCart(); })
      .finally(function () { if (el) { el.disabled = false; el.classList.remove('is-loading'); } });
  }

  function getCardVariants(panel) {
    if (!panel._variants) {
      var el = panel.querySelector('[data-card-variants]');
      try { panel._variants = JSON.parse(el.textContent); } catch (e) { panel._variants = []; }
    }
    return panel._variants;
  }

  // Recomputes disabled states from current selections; auto-adds when complete
  function updateCardPicker(panel) {
    var variants = getCardVariants(panel);
    var rows = panel.querySelectorAll('[data-opt-row]');
    var selected = [];
    for (var i = 0; i < rows.length; i++) {
      var sel = rows[i].querySelector('[data-opt-value].is-selected');
      selected.push(sel ? sel.dataset.value : null);
    }

    for (var r = 0; r < rows.length; r++) {
      var btns = rows[r].querySelectorAll('[data-opt-value]');
      for (var b = 0; b < btns.length; b++) {
        var val = btns[b].dataset.value;
        var possible = false;
        for (var v = 0; v < variants.length; v++) {
          var vt = variants[v];
          if (!vt.available) continue;
          var match = true;
          for (var o = 0; o < vt.options.length; o++) {
            if (o === r) { if (vt.options[o] !== val) { match = false; break; } }
            else if (selected[o] !== null && vt.options[o] !== selected[o]) { match = false; break; }
          }
          if (match) { possible = true; break; }
        }
        btns[b].disabled = !possible;
      }
    }

    var hint = panel.querySelector('[data-picker-hint]');
    if (hint) {
      var remaining = [];
      for (var h = 0; h < rows.length; h++) {
        if (selected[h] === null) {
          var lbl = rows[h].querySelector('.card__opt-label');
          if (lbl) remaining.push(lbl.textContent.trim().toLowerCase());
        }
      }
      if (remaining.length) hint.textContent = 'Select ' + remaining.join(' and ') + ' to add to cart';
    }

    var complete = selected.length > 0;
    for (var s = 0; s < selected.length; s++) { if (selected[s] === null) complete = false; }
    if (!complete) return;

    var target = null;
    for (var v2 = 0; v2 < variants.length; v2++) {
      var eq = true;
      for (var o2 = 0; o2 < selected.length; o2++) {
        if (variants[v2].options[o2] !== selected[o2]) { eq = false; break; }
      }
      if (eq) { target = variants[v2]; break; }
    }
    if (target && target.available) {
      panel.classList.remove('is-open');
      var selBtns = panel.querySelectorAll('[data-opt-value].is-selected');
      for (var c = 0; c < selBtns.length; c++) selBtns[c].classList.remove('is-selected');
      if (hint) {
        var allNames = [];
        for (var n = 0; n < rows.length; n++) {
          var lbl2 = rows[n].querySelector('.card__opt-label');
          if (lbl2) allNames.push(lbl2.textContent.trim().toLowerCase());
        }
        hint.textContent = 'Select ' + allNames.join(' and ') + ' to add to cart';
      }
      quickAdd(target.id);
    }
  }

  function initCart() {
    // Add to cart (intercept product form)
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      event.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      openCart(); // open instantly for perceived speed; content refreshes below
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { return fetchCart(false); })
        .catch(function () { closeCart(); form.submit(); })
        .finally(function () { if (btn) btn.disabled = false; });
    });

    // Open / close + quick add
    document.addEventListener('click', function (event) {
      // Card variant picker (slide-up bar inside product card media)
      if (!event.target.closest('[data-variant-picker]') && !event.target.closest('[data-variant-picker-toggle]')) {
        var openPickers = document.querySelectorAll('[data-variant-picker].is-open');
        for (var i = 0; i < openPickers.length; i++) openPickers[i].classList.remove('is-open');
      }
      var vt = event.target.closest('[data-variant-picker-toggle]');
      if (vt) {
        event.preventDefault();
        var wrap = vt.closest('.card__media-wrap');
        var panel = wrap && wrap.querySelector('[data-variant-picker]');
        if (panel) {
          var others = document.querySelectorAll('[data-variant-picker].is-open');
          for (var j = 0; j < others.length; j++) { if (others[j] !== panel) others[j].classList.remove('is-open'); }
          var isOpen = panel.classList.toggle('is-open');
          vt.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          if (isOpen) updateCardPicker(panel);
        }
        return;
      }
      if (event.target.closest('[data-variant-picker-close]')) {
        var closePanel = event.target.closest('[data-variant-picker]');
        if (closePanel) closePanel.classList.remove('is-open');
        return;
      }

      var ov = event.target.closest('[data-opt-value]');
      if (ov) {
        event.preventDefault();
        if (ov.disabled) return;
        var ovPanel = ov.closest('[data-variant-picker]');
        var ovRow = ov.closest('[data-opt-row]');
        var prevSel = ovRow.querySelector('[data-opt-value].is-selected');
        if (prevSel && prevSel !== ov) prevSel.classList.remove('is-selected');
        ov.classList.toggle('is-selected');
        updateCardPicker(ovPanel);
        return;
      }

      var qa = event.target.closest('[data-quick-add]');
      if (qa) {
        event.preventDefault();
        quickAdd(qa.dataset.variantId, qa);
        return;
      }
      if (event.target.closest('[data-cart-open]')) { event.preventDefault(); openCart(); fetchCart(false); return; }
      if (event.target.closest('[data-cart-close]')) { closeCart(); return; }

      var line = event.target.closest('.cart-line');
      if (!line) return;
      var key = line.dataset.key;
      var input = line.querySelector('[data-line-qty]');
      var qty = parseInt(input.value, 10) || 0;
      if (event.target.closest('[data-line-plus]')) changeLine(key, qty + 1);
      else if (event.target.closest('[data-line-minus]')) changeLine(key, Math.max(0, qty - 1));
      else if (event.target.closest('[data-line-remove]')) changeLine(key, 0);
    });

    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-line-qty]');
      if (!input) return;
      var line = input.closest('.cart-line');
      changeLine(line.dataset.key, Math.max(0, parseInt(input.value, 10) || 0));
    });

    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeCart(); });

    fetchCart(false); // sync count on load
  }

  /* Collection sort (custom dropdown) ------------------------------------- */
  function initSort() {
    var dd = document.querySelector('[data-sort-dropdown]');
    if (!dd) return;
    var toggle = dd.querySelector('[data-sort-toggle]');

    function close() { dd.classList.remove('is-open'); if (toggle) toggle.setAttribute('aria-expanded', 'false'); }

    if (toggle) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = dd.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    dd.querySelectorAll('[data-sort-value]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', opt.dataset.sortValue);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });

    document.addEventListener('click', function (e) { if (!dd.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* Account panel toggles (login/recover, address edit) ------------------- */
  function initAccountToggles() {
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-account-toggle]');
      if (!toggle) return;
      event.preventDefault();
      var target = toggle.getAttribute('data-account-toggle');
      document.querySelectorAll('[data-account-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-account-panel') !== target;
      });
    });
  }

  /* Size guide modal ------------------------------------------------------ */
  function initSizeGuide() {
    var modal = document.querySelector('[data-size-guide-modal]');
    if (!modal) return;
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-size-guide]')) {
        modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
      } else if (event.target.closest('[data-size-guide-close]')) {
        modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
      }
    });
  }

  /* Predictive search ----------------------------------------------------- */
  function initSearch() {
    var overlay = document.querySelector('[data-search]');
    if (!overlay) return;
    var input = overlay.querySelector('[data-search-input]');
    var results = overlay.querySelector('[data-search-results]');
    var timer;

    function open() {
      overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { input.focus(); }, 50);
    }
    function close() {
      overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function search(q) {
      if (q.length < 2) { results.innerHTML = ''; return; }
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var res = (data.resources && data.resources.results) || {};
          var products = res.products || [];
          var collections = res.collections || [];
          if (!products.length && !collections.length) {
            results.innerHTML = '<p class="search-overlay__empty">No results for &ldquo;' + q + '&rdquo;</p>';
            return;
          }
          var html = '';
          if (collections.length) {
            html += '<div class="search-overlay__cols">' + collections.map(function (c) {
              return '<a href="' + c.url + '" class="search-overlay__col">' + c.title + '</a>';
            }).join('') + '</div>';
          }
          html += '<div class="search-overlay__grid">' + products.map(function (p) {
            var img = (p.featured_image && p.featured_image.url) || p.image || '';
            var imgTag = img ? '<img src="' + img + '" alt="" width="60" height="75" loading="lazy">' : '';
            var vendor = p.vendor ? '<span class="search-overlay__vendor">' + p.vendor + '</span>' : '';
            return '<a href="' + p.url + '" class="search-overlay__item">' + imgTag +
              '<span class="search-overlay__meta">' + vendor + '<span class="search-overlay__title">' + p.title + '</span></span></a>';
          }).join('') + '</div>';
          html += '<a href="/search?q=' + encodeURIComponent(q) + '" class="link-arrow search-overlay__all">See all results</a>';
          results.innerHTML = html;
        });
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-search-open]')) { event.preventDefault(); open(); }
      else if (event.target.closest('[data-search-close]')) { close(); }
    });
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      timer = setTimeout(function () { search(q); }, 250);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* Option buttons (size pills + colour swatches) ------------------------- */
  function initSwatches() {
    document.addEventListener('click', function (event) {
      var opt = event.target.closest('[data-opt]');
      if (!opt) return;
      var field = opt.closest('.product__field');
      if (!field) return;
      var select = field.querySelector('[data-option-select]');
      if (select) { select.value = opt.dataset.value; select.dispatchEvent(new Event('change', { bubbles: true })); }
      field.querySelectorAll('[data-opt]').forEach(function (s) { s.classList.remove('is-active'); });
      opt.classList.add('is-active');
      var val = field.querySelector('[data-opt-value]');
      if (val) val.textContent = opt.dataset.value;
    });
  }

  /* Scroll reveal --------------------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.section, .hero');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Back to top ----------------------------------------------------------- */
  function initBackToTop() {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('is-visible', window.scrollY > 600);
    }, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* Mobile sticky buy bar ------------------------------------------------- */
  function initBuyBar() {
    var bar = document.querySelector('[data-buybar]');
    var mainAdd = document.querySelector('[data-add-to-cart]');
    if (!bar || !mainAdd) return;
    var buyAdd = bar.querySelector('[data-buybar-add]');
    if (buyAdd) buyAdd.addEventListener('click', function () {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.classList.toggle('is-visible', !en.isIntersecting); });
      }, { threshold: 0 });
      io.observe(mainAdd);
    }
  }

  /* Wishlist (localStorage) ----------------------------------------------- */
  var WISH_KEY = 'kb_wishlist';
  function wishGet() { try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; } }
  function wishSet(arr) { localStorage.setItem(WISH_KEY, JSON.stringify(arr)); }
  function wishUpdateCount() {
    var n = wishGet().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }
  function wishMark() {
    var list = wishGet();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = list.indexOf(btn.dataset.handle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = btn.querySelector('[data-wish-label]');
      if (label) label.textContent = active ? 'In your wishlist' : 'Add to wishlist';
    });
  }
  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var list = wishGet();
    grid.innerHTML = '';
    if (!list.length) { if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    list.forEach(function (handle) {
      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var img = p.featured_image ? String(p.featured_image).replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '';
          var card = document.createElement('div');
          card.className = 'card';
          card.innerHTML =
            '<div class="card__media-wrap">' +
              '<button class="card__wish is-active" type="button" data-wishlist-toggle data-handle="' + handle + '" aria-pressed="true" aria-label="Remove from wishlist">' +
                '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.7-9A5 5 0 0 1 12 6a5 5 0 0 1 9.7 6c-2.2 4.4-9.7 9-9.7 9Z"/></svg>' +
              '</button>' +
              '<a href="' + p.url + '" class="card__media-link"><div class="card__media">' + (img ? '<img src="' + img + '" alt="" width="300" height="375" loading="lazy">' : '') + '</div></a>' +
            '</div>' +
            '<div class="card__info"><h3 class="card__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
            '<div class="card__price">' + formatMoney(p.price) + '</div></div>';
          grid.appendChild(card);
        });
    });
  }
  function initWishlist() {
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      event.preventDefault();
      var list = wishGet();
      var h = btn.dataset.handle;
      var i = list.indexOf(h);
      if (i === -1) list.push(h); else list.splice(i, 1);
      wishSet(list);
      wishUpdateCount();
      wishMark();
      if (document.querySelector('[data-wishlist-grid]')) renderWishlistPage();
    });
    wishUpdateCount();
    wishMark();
    renderWishlistPage();
  }

  /* Cookie consent -------------------------------------------------------- */
  function initCookie() {
    var bar = document.querySelector('[data-cookie-bar]');
    if (!bar) return;
    if (localStorage.getItem('kb_cookie')) return;
    setTimeout(function () { bar.hidden = false; bar.classList.add('is-visible'); }, 800);
    bar.addEventListener('click', function (event) {
      if (event.target.closest('[data-cookie-accept]')) { localStorage.setItem('kb_cookie', 'accepted'); bar.classList.remove('is-visible'); setTimeout(function () { bar.hidden = true; }, 300); }
      else if (event.target.closest('[data-cookie-decline]')) { localStorage.setItem('kb_cookie', 'declined'); bar.classList.remove('is-visible'); setTimeout(function () { bar.hidden = true; }, 300); }
    });
  }

  /* Quick view ------------------------------------------------------------ */
  function initQuickView() {
    var modal = document.querySelector('[data-quickview-modal]');
    var content = modal && modal.querySelector('[data-quickview-content]');
    if (!modal || !content) return;

    function open() { modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function close() { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

    function sized(url, w) {
      if (!url) return '';
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      return url + sep + 'width=' + (w || 800);
    }
    function render(p) {
      var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
      var images = (p.images && p.images.length) ? p.images : (p.featured_image ? [p.featured_image] : []);
      var mediaHtml = '<div class="quickview__media">' +
        '<div class="quickview__stage">' + (images[0] ? '<img data-qv-main src="' + sized(images[0], 800) + '" alt="' + p.title + '">' : '') + '</div>' +
        (images.length > 1 ? '<div class="quickview__thumbs">' + images.slice(0, 5).map(function (im, i) {
          return '<button type="button" class="quickview__thumb' + (i === 0 ? ' is-active' : '') + '" data-qv-thumb data-full="' + sized(im, 800) + '" aria-label="Image ' + (i + 1) + '"><img src="' + sized(im, 160) + '" alt=""></button>';
        }).join('') + '</div>' : '') +
        '</div>';
      var hasOptions = !(p.variants.length === 1 && p.variants[0].title === 'Default Title');
      var optionsHtml = '';
      if (hasOptions) {
        p.options.forEach(function (opt, idx) {
          var label = (opt && typeof opt === 'object') ? (opt.name || '') : opt;
          var values = [];
          p.variants.forEach(function (vr) { var val = vr.options[idx]; if (values.indexOf(val) === -1) values.push(val); });
          optionsHtml += '<div class="product__field"><label>' + label + '</label><div class="select-wrap"><select data-qv-option>' +
            values.map(function (val) { return '<option value="' + val + '">' + val + '</option>'; }).join('') + '</select></div></div>';
        });
      }
      var priceHtml = (v.compare_at_price && v.compare_at_price > v.price)
        ? '<span class="price--compare">' + formatMoney(v.compare_at_price) + '</span> <span class="price--sale">' + formatMoney(v.price) + '</span>'
        : formatMoney(v.price);
      content.innerHTML =
        mediaHtml +
        '<div class="quickview__details">' +
          (p.vendor ? '<div class="card__vendor">' + p.vendor + '</div>' : '') +
          '<h2 class="quickview__title">' + p.title + '</h2>' +
          '<div class="quickview__price" data-qv-price>' + priceHtml + '</div>' +
          optionsHtml +
          '<div class="product__buy"><div class="quantity quantity--sm">' +
            '<button type="button" class="quantity__btn" data-qty-minus aria-label="Decrease">−</button>' +
            '<input type="number" value="1" min="1" data-qv-qty data-qty-input aria-label="Quantity">' +
            '<button type="button" class="quantity__btn" data-qty-plus aria-label="Increase">+</button></div>' +
            '<button type="button" class="btn btn--full" data-qv-add data-id="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
            (v.available ? window.theme.strings.addToCart : window.theme.strings.soldOut) + '</button></div>' +
          '<a href="' + p.url + '" class="link-arrow quickview__full">' + (window.theme.strings.viewDetails || 'View full details') + ' →</a>' +
        '</div>';

      var selects = content.querySelectorAll('[data-qv-option]');
      var priceEl = content.querySelector('[data-qv-price]');
      var addBtn = content.querySelector('[data-qv-add]');
      selects.forEach(function (s) {
        s.addEventListener('change', function () {
          var chosen = Array.prototype.map.call(selects, function (x) { return x.value; });
          var match = p.variants.filter(function (vr) { return vr.options.every(function (o, i) { return o === chosen[i]; }); })[0];
          if (!match) return;
          addBtn.dataset.id = match.id;
          priceEl.textContent = formatMoney(match.price);
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
        });
      });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-quick-view]');
      if (trigger) {
        event.preventDefault();
        content.innerHTML = '<p class="quickview__loading">Loading…</p>';
        open();
        fetch('/products/' + trigger.dataset.handle + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(render)
          .catch(function () { window.location.href = '/products/' + trigger.dataset.handle; });
        return;
      }
      if (event.target.closest('[data-quickview-close]')) { close(); return; }
      var thumb = event.target.closest('[data-qv-thumb]');
      if (thumb) {
        var main = content.querySelector('[data-qv-main]');
        if (main) main.src = thumb.dataset.full;
        content.querySelectorAll('[data-qv-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        return;
      }
      var add = event.target.closest('[data-qv-add]');
      if (add) {
        var qtyEl = content.querySelector('[data-qv-qty]');
        var qty = parseInt(qtyEl && qtyEl.value, 10) || 1;
        add.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: add.dataset.id, quantity: qty })
        }).then(function () { close(); fetchCart(true); })
          .catch(function () {})
          .finally(function () { add.disabled = false; });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* Product image hover zoom ---------------------------------------------- */
  function initZoom() {
    var stage = document.querySelector('[data-product-stage]');
    var zoom = document.querySelector('[data-product-zoom]');
    if (!stage || !zoom) return;
    if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;

    function positionZoom() {
      var prod = stage.closest('.product');
      if (!prod) return;
      var pr = prod.getBoundingClientRect();
      var sr = stage.getBoundingClientRect();
      var rtl = document.documentElement.getAttribute('dir') === 'rtl';
      zoom.style.top = (sr.top - pr.top) + 'px';
      if (rtl) {
        zoom.style.right = (sr.right - pr.left + 20) + 'px';
        zoom.style.left = 'auto';
      } else {
        zoom.style.left = (sr.right - pr.left + 20) + 'px';
        zoom.style.right = 'auto';
      }
    }
    stage.addEventListener('mouseenter', function () {
      zoom.style.backgroundImage = 'url(' + (stage.currentSrc || stage.src) + ')';
      positionZoom();
      zoom.classList.add('is-active');
    });
    stage.addEventListener('mouseleave', function () { zoom.classList.remove('is-active'); });
    stage.addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect();
      var x = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
      var y = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
      zoom.style.backgroundPosition = x + '% ' + y + '%';
    });
  }

  /* Shared JS product card (for wishlist / recently viewed) --------------- */
  function jsCard(p, handle) {
    var img = p.featured_image ? String(p.featured_image).replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '';
    var heart = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 21s-7.5-4.6-9.7-9A5 5 0 0 1 12 6a5 5 0 0 1 9.7 6c-2.2 4.4-9.7 9-9.7 9Z"/></svg>';
    var eye = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>';
    return '<div class="card"><div class="card__media-wrap">' +
      '<button class="card__wish" type="button" data-wishlist-toggle data-handle="' + handle + '" aria-label="Wishlist" aria-pressed="false">' + heart + '</button>' +
      '<button class="card__quickview" type="button" data-quick-view data-handle="' + handle + '" aria-label="Quick view">' + eye + '</button>' +
      '<a href="' + p.url + '" class="card__media-link"><div class="card__media">' + (img ? '<img src="' + img + '" alt="" width="300" height="375" loading="lazy">' : '') + '</div></a>' +
      '</div><div class="card__info"><h3 class="card__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
      '<div class="card__price">' + formatMoney(p.price) + '</div></div></div>';
  }

  /* Recently viewed ------------------------------------------------------- */
  function initRecentlyViewed() {
    var KEY = 'kb_recently';
    var grid = document.querySelector('[data-recently-grid]');
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    var current = grid ? grid.dataset.current : null;

    if (grid) {
      var toShow = list.filter(function (h) { return h && h !== current; }).slice(0, parseInt(grid.style.getPropertyValue('--columns'), 10) || 4);
      if (toShow.length) {
        var section = grid.closest('[data-recently-section]');
        if (section) section.hidden = false;
        var done = 0;
        toShow.forEach(function (handle) {
          fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (p) {
              if (p) grid.insertAdjacentHTML('beforeend', jsCard(p, handle));
              done++;
              if (done === toShow.length) wishMark();
            });
        });
      }
    }

    if (current) {
      list = list.filter(function (h) { return h !== current; });
      list.unshift(current);
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12)));
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initVariantPickers();
    initLocalization();
    initSlideshows();
    initAnnouncement();
    initFilterDrawer();
    initGallery();
    initProductGallery();
    initZoom();
    initQuantity();
    initCart();
    initSort();
    initAccountToggles();
    initSizeGuide();
    initSearch();
    initSwatches();
    initReveal();
    initBackToTop();
    initBuyBar();
    initWishlist();
    initCookie();
    initQuickView();
    initRecentlyViewed();
  });
})();
